<upp-guest-ticket-preview *ngIf="ShowTicket" uppDataid="guestready-ticket-preview"
    [ticket]="ShowTicket"
    color="success"
    (Done)="OnShowTicket(null)"
></upp-guest-ticket-preview>

<ng-container *ngIf="ShowTicket === null">
    <upp-scrollable class="guest-panel-scroll" [scrollbar]="'none'">
        <div class="body">
            <ion-card>
                <ion-icon color="success" name="checkmark-circle-outline"></ion-icon>
                <ion-card-title color="success">
                    {{ tr('@place_ready_title') }}
                </ion-card-title>
                <ion-card-content>
                    <span *ngIf="place?.TableService">{{ tr('@place_ready_message_waiter') }}</span>
                    <span *ngIf="!place?.TableService">{{ tr('@place_ready_message') }}</span>
                </ion-card-content>
            </ion-card>
        </div>

        <ion-list class="ready">
            <upp-guest-ticket-thumb *ngFor="let ticket of Tickets; trackBy: TicketTrack"
                uppDataid="guestready-show-ticket"
                [ticket]="ticket"
                mode="READY"
                (Open)="OnShowTicket($event)">
            </upp-guest-ticket-thumb>
        </ion-list>
        <div class="list-spacer"></div>
        <div class="form-buttons">
            <ion-button uppDataid="guestready-accept-button" color="success" size="large" expand="block" (click)="OnAccept()">
                {{ tr('@place_ready_accept') }}
            </ion-button>
        </div>
    </upp-scrollable>
</ng-container>
